<!--
 * @Author: ze.wang@diact.com
 * @Date: 2022-11-25 15:19:10
 * @Function: Please Input Function
-->
<template>
  <div>
    <div class="voice-button-row" v-show="!isRecording">
      <div class="voice-button" :style="{backgroundColor: primaryColor}" @click="getAuthInit" :class="{'diabled-button': diabled}">
        <img class="voice-button-icon" :src="require('@/assets/images/edit/config/voice-btn-icon.png')" alt="语音按钮" />
      </div>
      <div class="voice-button-info">
        {{ diabled ? cvtLang('tipsMaxSubmit', config.tipsMaxSubmit) : cvtLang('tipsMusicStart', config.tipsMusicStart) }}
      </div>
    </div>

    <div class="record-voice-container" v-show="isRecording">
      <div class="wave-box" ref="waveBox" @click="stopAction"></div>
      <div class="record-voice-info">
        {{ cvtLang('tipsMusicEnd', config.tipsMusicEnd) }} {{ countDownTime + 's' }}
      </div>
    </div>
  </div>
  
</template>

<script>
import Recorder from 'recorder-core';

import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';

import 'recorder-core/src/extensions/frequency.histogram.view';
import 'recorder-core/src/extensions/lib.fft';

export default {
  name: "RecordVoice",
  components: {},
  props: {
    diabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: {}
    },
    cvtLang: {
      type: Function,
      defautl: () => {}
    },
    primaryColor: {
      type: String,
      default: '#45BAA3'
    },
  },
  data() {
    return {
      isRecording: false, // 是否是记录状态

      countDownTime: 60,
      
      mediaRecorder: null, // 音频记录器
      waveInstance: null, // 音浪实例

      sampleRate: 16000, // 采样率

    };
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    this.distroyAction()
  }, //生命周期 - 销毁完成
  methods: {
    // 授权并初始化并开始录音
    getAuthInit(){
      if(this.diabled){
        return
      }
      const that = this;
      this.isRecording = false;
      this.mediaRecorder = Recorder({
        type: 'mp3',
        sampleRate: this.sampleRate,
        bitRate: 16, // mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
        onProcess(buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
          // 录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
          // 可实时绘制波形（extensions目录内的waveview.js、wavesurfer.view.js、frequency.histogram.view.js插件功能）
          // 可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
          // 可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等
          that.waveInstance.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate);
          that.countDown(bufferDuration)
          if(bufferDuration >= 60 * 1000){
            that.stopAction()
          }
        },
      });

      this.mediaRecorder.open(() => { // 打开麦克风授权获得相关资源
        this.isRecording = true;
        this.$nextTick(() => {
          this.initWave();
        });
      }, (msg, isUserNotAllow) => { // 用户拒绝未授权或不支持
        console.log(`${isUserNotAllow ? 'UserNotAllow，' : ''}无法录音:${msg}`);
      });
    },

    // 倒计时
    countDown(bufferDuration){
      const max = 60 * 1000
      this.countDownTime = parseInt((max - bufferDuration)/1000)
    },

    // 初始化wave
    initWave() {
      const set = {
        elem: this.$refs.waveBox, // 自动显示到dom，并以此dom大小为显示大小
        scale: 2, // 缩放系数，应为正整数，使用2(3? no!)倍宽高进行绘制，避免移动端绘制模糊

        fps: 20, // 绘制帧率，不可过高

        lineCount: 80, // 直方图柱子数量，数量的多少对性能影响不大，密集运算集中在FFT算法中
        // eslint-disable-next-line max-len
        widthRatio: 0.8, // 柱子线条宽度占比，为所有柱子占用整个视图宽度的比例，剩下的空白区域均匀插入柱子中间；默认值也基本相当于一根柱子占0.6，一根空白占0.4；设为1不留空白，当视图不足容下所有柱子时也不留空白
        spaceWidth: 0, // 柱子间空白固定基础宽度，柱子宽度自适应，当不为0时widthRatio无效，当视图不足容下所有柱子时将不会留空白，允许为负数，让柱子发生重叠
        minHeight: 1, // 柱子保留基础高度，position不为±1时应该保留点高度
        position: 0, // 绘制位置，取值-1到1，-1为最底下，0为中间，1为最顶上，小数为百分比
        mirrorEnable: true, // 是否启用镜像，如果启用，视图宽度会分成左右两块，右边这块进行绘制，左边这块进行镜像（以中间这根柱子的中心进行镜像）

        stripeEnable: true, // 是否启用柱子顶上的峰值小横条，position不是-1时应当关闭，否则会很丑
        stripeHeight: 1, // 峰值小横条基础高度
        stripeMargin: 6, // 峰值小横条和柱子保持的基础距离

        fallDuration: 700, // 柱子从最顶上下降到最底部最长时间ms
        stripeFallDuration: 1000, // 峰值小横条从最顶上下降到底部最长时间ms

        // 柱子颜色配置：[位置，css颜色，...] 位置: 取值0.0-1.0之间
        linear: [0, this.primaryColor, 0.4, '#AE6FFF', 1, '#AE6FFF'],
        // 峰值小横条渐变颜色配置，取值格式和linear一致，留空为柱子的渐变颜色
        stripeLinear: [0, this.primaryColor, 1, '#AE6FFF'],

        shadowBlur: 0, // 柱子阴影基础大小，设为0不显示阴影，如果柱子数量太多时请勿开启，非常影响性能
        shadowColor: '#bbb', // 柱子阴影颜色
        stripeShadowBlur: -1, // 峰值小横条阴影基础大小，设为0不显示阴影，-1为柱子的大小，如果柱子数量太多时请勿开启，非常影响性能
        stripeShadowColor: '', // 峰值小横条阴影颜色，留空为柱子的阴影颜色
      };

      this.waveInstance = Recorder.FrequencyHistogramView(set);
      this.startAction()
    },

    // 开启
    startAction() {
      this.mediaRecorder.start();
    },

    // 停止
    stopAction() {
      this.mediaRecorder.stop((blob, duration) => {
        // 释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
        this.distroyAction();

        const audioSrc = window.URL.createObjectURL(blob);
        this.$emit('ok', { src: audioSrc, blob, duration })
      }, (msg) => {
        console.log(`录音失败:${msg}`);
      });
    },

    // 释放
    distroyAction() {
      this.mediaRecorder && this.mediaRecorder.close();
      this.mediaRecorder = null;
      this.waveInstance = null;
      this.isRecording = false;
    },

  }
}
</script>
<style lang="scss" scoped>

$contentBoxHeight: 40px;
$contentBoxWidth: 100%;
$iconHeight: 24px;
$contentInfoSpace: 8px;
$infoRowHeight: 22px;
$fontSize: 14px;

.record-voice-container{
  .wave-box{
    width: $contentBoxWidth;
    min-width: $contentBoxHeight * 2;
    height: ($contentBoxHeight + 40px) * 2;
    margin: 0 auto;
    margin-bottom: $contentInfoSpace * 2;
  }
  .record-voice-info{
    font-weight: 400;
    font-size: $fontSize * 2;
    line-height: $infoRowHeight * 2;
    color: #515A6E;
    text-align: center;
  }
}

.voice-button-row{
  // padding: 16px 0;
  text-align: center;
  width: 100%;
  .voice-button{
    width: $contentBoxHeight * 2;
    min-width: $contentBoxHeight * 2;
    height: $contentBoxHeight * 2;
    border-radius: 100%;
    background-color: $color-primary;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: $contentInfoSpace * 2;
    &.diabled-button{
      background-color: #C8D3DF;
    }
    .voice-button-icon{
      width: $iconHeight * 2;
      height: $iconHeight * 2;
    }
  }
  .voice-button-info{
    font-weight: 400;
    font-size: $fontSize * 2;
    line-height: $infoRowHeight * 2;
    color: #515A6E;
  }
}

.answer-pc{
  .record-voice-container{
    .wave-box{
      width: 335px;
      min-width: $contentBoxHeight * 1;
      height: ($contentBoxHeight + 40px) * 1;
      margin: 0 auto;
      margin-bottom: $contentInfoSpace * 1;
      cursor: pointer;
    }
    .record-voice-info{
      font-weight: 400;
      font-size: $fontSize * 1;
      line-height: $infoRowHeight * 1;
      color: #515A6E;
      text-align: center;
    }
  }

  .voice-button-row{
    // padding: 16px 0;
    text-align: center;
    width: 100%;
    .voice-button{
      width: $contentBoxHeight * 1;
      min-width: $contentBoxHeight * 1;
      height: $contentBoxHeight * 1;
      border-radius: 100%;
      background-color: $color-primary;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: $contentInfoSpace * 1;
      cursor: pointer;
      &.diabled-button{
        background-color: #C8D3DF;
      }
      .voice-button-icon{
        width: $iconHeight * 1;
        height: $iconHeight * 1;
      }
    }
    .voice-button-info{
      font-weight: 400;
      font-size: $fontSize * 1;
      line-height: $infoRowHeight * 1;
      color: #515A6E;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/editor/MusicBox/components/RecordVoice.vue